import { FC } from "react";

import { BentoElement, BentoElementType, BentoTextElement, EditorialModuleImage } from "@/types";

import TiledImage from "./TiledImage";
import TiledText from "./TiledText";

const TiledBlockV3: FC<{ items: BentoElement[] }> = ({ items }) => {
  items = items.map((item) => {
    if (item.type === BentoElementType.image) {
      return item as EditorialModuleImage;
    } else if ((item.type = BentoElementType.text)) {
      return item as BentoTextElement;
    }
    return item;
  });

  return (
    <>
      <div className="grid grid-cols-1">
        <div className="col-span-1 grid grid-cols-2 gap-xs">
          {items.map((item, index) => (
            <>
              {item.type === BentoElementType.image ? (
                <TiledImage entry={item as EditorialModuleImage}></TiledImage>
              ) : (
                item.type === BentoElementType.text && <TiledText slideIndex={index} key={item.id} entry={item as BentoTextElement} />
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};
export default TiledBlockV3;
